<div class="deposit-select-check-in">
  <section>
    <info-page-header label="Pago de Fianza" [navigateTo]="'/'"></info-page-header>
    <div class="deposit-select-check-in-content">
      <p class="text-check">
        Para acceder a la vivienda, se requiere un depósito por daños. Preautorizaremos el depósito estipulado en su tarjeta, que se desbloqueará después de su estancia. Por favor, seleccione a la persona responsable de este depósito de la siguiente lista:

      </p>

      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="form__field">
          <label for="checkin"></label>
          <select id="checkin" formControlName="checkin">
            <option value="" disabled>Seleccione una opción</option>
            <option
              *ngFor="let checkin of checkins"
              [value]="checkin.id">
              {{ getFullName(checkin) }}
            </option>
          </select>
        </div>

        <!-- Botón principal -->
        <button
          type="submit"
          class="primary-btn"
          [disabled]="form.invalid || form.disabled"
        >
          Confirmar
        </button>
      </form>
    </div>
  </section>
</div>
